/**
 * Plugin vue-i18n
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/tran.js';

import jp_en from '@/lang/jp_en.json';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE, // set fallback locale
  messages: { jp_en } // set locale messages
});
